import type { TeachingEvidenceModel } from "@/api/cle-api";
import { UserQueryContext } from "@/context/UserContext";
import { formatLessons } from "@/util/number";
import { useContext } from "react";

import { DetailItem } from "../person/id/Efteruddannelse/DetailItem";
import { ExpandableText } from "../person/id/Efteruddannelse/ExpandableText";
import { TeachingValidationEditModal } from "./TeachingValidationEditModal";

interface TeachingValidationProps {
  teaching: TeachingEvidenceModel;
  onTeachingUpdated?: (updated: TeachingEvidenceModel) => void;
}

export const TeachingValidation = ({
  teaching,
  onTeachingUpdated,
}: TeachingValidationProps) => {
  const { user, hasPermission } = useContext(UserQueryContext);
  // Reported (indberettet) evidence backs a signed declaration and is immutable;
  // the API refuses these edits with 409 EVIDENCE_ALREADY_REPORTED.
  const canEdit = hasPermission(user, "TilsynWrite") && !teaching.isReported;

  const handleSave = (updated: TeachingEvidenceModel) => {
    onTeachingUpdated?.(updated);
  };

  return (
    <div className="c-card c-item-list">
      <div className="flex-100 d-flex justify-content-between flex-row align-items-center">
        <h3 className="mb-0">Undervisningsoplysninger</h3>
        {canEdit && (
          <TeachingValidationEditModal
            teaching={teaching}
            onSave={handleSave}
          />
        )}
      </div>
      <div className="d-flex flex-column gap-2">
        <DetailItem
          label="Antal lektioner"
          value={formatLessons(teaching.numberOfLessons)}
        />
        <DetailItem
          label="Beskrivelse"
          value={
            <ExpandableText
              id="teaching-description-toggle"
              text={teaching.description}
            />
          }
        />
      </div>
    </div>
  );
};
